import type { I18nProvider } from "@refinedev/core";

// Turkish texts for the parts Refine draws itself (menu, error pages, notifications). Office
// screens write their texts directly; Ant Design components use antd's tr_TR locale.
const texts: Record<string, string> = {
  "buttons.logout": "Çıkış yap",
  "buttons.cancel": "Vazgeç",
  "buttons.confirm": "Emin misin?",
  "buttons.delete": "Sil",
  "buttons.save": "Kaydet",
  "buttons.refresh": "Yenile",
  "buttons.clear": "Temizle",
  "buttons.filter": "Filtrele",
  "buttons.notAccessTitle": "Bu işlem için yetkin yok.",
  "pages.error.404": "Aradığın sayfa bulunamadı.",
  "pages.error.backHome": "Ana sayfaya dön",
  "pages.error.info": "Ayrıntı",
  "notifications.success": "İşlem tamamlandı",
  "notifications.error": "Bir hata oluştu (kod: {{statusCode}})",
  "notifications.createSuccess": "Kaydedildi",
  "notifications.editSuccess": "Güncellendi",
  "notifications.deleteSuccess": "Silindi",
  "notifications.createError": "Kaydedilemedi (kod: {{statusCode}})",
  "notifications.editError": "Güncellenemedi (kod: {{statusCode}})",
  "notifications.deleteError": "Silinemedi (kod: {{statusCode}})",
  "actions.list": "Liste",
  "actions.show": "Detay",
  "actions.create": "Oluştur",
  "actions.edit": "Düzenle",
  warnWhenUnsavedChanges: "Kaydedilmemiş değişiklikler var. Sayfadan çıkılsın mı?",
};

export const i18nProvider: I18nProvider = {
  translate: (key: string, options?: unknown, defaultMessage?: string) => {
    const text = texts[key] ?? (typeof options === "string" ? options : defaultMessage) ?? key;
    if (!options || typeof options !== "object") return text;
    const values = options as Record<string, unknown>;
    return text.replace(/\{\{(\w+)\}\}/g, (_, name: string) => String(values[name] ?? ""));
  },
  changeLocale: async () => undefined,
  getLocale: () => "tr",
};
